// hacky debug.ts, can be replaced with a proper logging solution
// @ts-ignore
class Logger {
    get debugLoggingEnabled() {
        return window['SEGMENT_CONSENT_WRAPPER_DEBUG_MODE'] === true;
    }
    enableDebugLogging() {
        ;
        window['SEGMENT_CONSENT_WRAPPER_DEBUG_MODE'] = true;
    }
    debug(...args) {
        if (this.debugLoggingEnabled) {
            console.log('[consent wrapper debug]', ...args);
        }
    }
}
export const logger = new Logger();
//# sourceMappingURL=logger.js.map